import { createTheme } from "@aws-amplify/ui-react";

// Amplify UI v6 theme override for Cognito <Authenticator>.
// Brand tokens mirror DESIGN.md: Inter body, deep-teal accent for CTAs
// (rust retired 2026-06-18), 8px corner radius, hairline borders against
// the off-white background.
// Imported by /login and /signup, applied via <ThemeProvider theme={thexisTheme}>.
export const thexisTheme = createTheme({
  name: "thexis",
  tokens: {
    fonts: {
      default: {
        variable: { value: "var(--font-inter), system-ui, sans-serif" },
        static: { value: "var(--font-inter), system-ui, sans-serif" },
      },
    },
    colors: {
      brand: {
        primary: {
          10: { value: "#DCEEEB" },
          20: { value: "#A9D2CC" },
          40: { value: "#2E8C84" },
          60: { value: "#0E5C63" },
          80: { value: "#0E5C63" },
          90: { value: "#0B4A43" },
          100: { value: "#0B4A43" },
        },
      },
      font: {
        primary: { value: "#15171A" },
        secondary: { value: "#5B6066" },
        interactive: { value: "#0E5C63" },
      },
      border: {
        primary: { value: "rgba(21, 23, 26, 0.18)" },
        secondary: { value: "rgba(21, 23, 26, 0.11)" },
      },
      background: {
        primary: { value: "#FFFFFF" },
        secondary: { value: "#FAF8F4" },
      },
    },
    radii: {
      small: { value: "6px" },
      medium: { value: "8px" },
      large: { value: "10px" },
    },
    components: {
      authenticator: {
        // The Authenticator router renders the form's bounding box. Make it
        // transparent + borderless so it sits flush inside our outer AuthCard
        // wrapper (login/signup pages). Without these overrides Amplify
        // renders a default white card-in-card with hairline borders.
        router: {
          backgroundColor: { value: "transparent" },
          borderColor: { value: "transparent" },
          borderWidth: { value: "0" },
          boxShadow: { value: "none" },
        },
        form: {
          padding: { value: "0" },
        },
        container: {
          widthMax: { value: "100%" },
        },
      },
      button: {
        primary: {
          backgroundColor: { value: "{colors.brand.primary.80}" },
          color: { value: "#FFFFFF" },
          _hover: {
            backgroundColor: { value: "{colors.brand.primary.90}" },
          },
          _focus: {
            backgroundColor: { value: "{colors.brand.primary.90}" },
            boxShadow: { value: "0 0 0 3px rgba(14, 92, 99, 0.18)" },
          },
        },
        link: {
          color: { value: "{colors.brand.primary.80}" },
          _hover: { color: { value: "{colors.brand.primary.90}" } },
        },
      },
      fieldcontrol: {
        borderColor: { value: "{colors.border.primary}" },
        _focus: {
          borderColor: { value: "{colors.brand.primary.80}" },
          boxShadow: { value: "0 0 0 3px rgba(14, 92, 99, 0.12)" },
        },
      },
      tabs: {
        item: {
          color: { value: "{colors.font.secondary}" },
          _active: { color: { value: "{colors.brand.primary.80}" } },
          _hover: { color: { value: "{colors.brand.primary.80}" } },
          _focus: { color: { value: "{colors.brand.primary.80}" } },
        },
      },
    },
  },
});
